import React, {CSSProperties} from "react";
import {Media} from "@/constants/media_query";

type TMobileComponentWrapper = {
  className?: string;
  style?: CSSProperties;
}

const MobileComponentWrapper:React.FC<TMobileComponentWrapper> = (props) => {
  return (
    <Media lessThan="lg" className={props.className}><div style={props.style}>{props.children}</div></Media>
  )
}
export default MobileComponentWrapper;
